import Vue from 'vue'
import Router from 'vue-router'


/* Layout */
import Layout from '../views/layout/AppLayout'

import index from '../views/Index'
import profile from '../views/Profile'
import shares from '../views/Shares'
import archive from '../views/Archive'
import postDetail from '../views/PostDetail'
import tagContent from '../views/TagContent'
import search from '../views/Search'
import digital_album from '../views/DigitalAlbum'
import image from '../views/Image'
import optionAnalysis from '../views/OptionAnalysis'
import marketReport from '../views/MarketReport'
import stockWatch from '../views/StockWatch'

Vue.use(Router)


export const constantRouterMap=[
  // { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  // { path: '/404', component: () => import('@/views/404'), hidden: true },
    {
      path: '/',
      component: Layout,
      redirect: '/index',
      children: [
        {
        path: 'index',
        name: 'index',
        component: index
        },
        {
          path: '/index/:topage',
          name: 'pageRouter',
          component: index,
          props: true
        },
        {
          path: '/postDetail/:url',
          name: 'postDetail',
          component: postDetail,
          props: false
        },
        {
          path: '/archive',
          name: 'archive',
          component: archive
        },
        {
          path: '/search',
          name: 'search',
          component: search
        },
        {
          path: '/shares',
          name: 'shares',
          component: shares
        },
        {
          path: '/tag/:tag/:topage?',
          name: 'tagContent',
          component: tagContent,
          props: true
        },
        {
          path: '/profile/:topage?',
          name: 'profile',
          component: profile
        },{
          path: '/love-timeline',
          name: 'digital-album',
          component: digital_album
        },
        {
          path: '/image',
          name: 'image',
          component: image
        },
        {
          path: '/options',
          name: 'options',
          component: optionAnalysis
        },
        {
          path: '/market',
          name: 'market',
          component: marketReport
        },
        {
          path: '/stocks',
          name: 'stocks',
          component: stockWatch
        }
      ]
    }
]



const router = new Router({
  mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

// 路由切换后清除主题菜单锁定的滚动状态（menu-active 会把 overflow-y 锁为 hidden）
router.afterEach(() => {
  document.querySelector('html').classList.remove('menu-active')
})

export default router
